import api from "@/plugins/api/EntryPoint";

export default {
  async getPaymentHistory(params, callBackFn) {
    console.log("getPaymentHistory: ", JSON.stringify(params))
    await api.post(`history/payments`, params, callBackFn);
  },
  async getPaymentHistoryFromEasyPayDb(params, callBackFn) {
    console.log("getPaymentHistoryFromEasyPayDb: ", JSON.stringify(params))
    await api.post(`history/payments-easy-pay-db`, { ls: params }, callBackFn);
  },
};
